
export const commonProps = {
  // 是否自动渲染
  autoRender: {
    type: Boolean,
    default: true
  },
  data: {
    type: Array,
    default: () => ([])
  },
  option: Object,
  showLegendMoreConfig: {
    type: Boolean,
    default: true
  },
  legendMoreMapConfig: {
    type: Object,
    default: () => ({})
  },
  tooltipFormatterConfig: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/props.js